enum ActionButtonType {
  Create = 0,
  Update = 1,
}
export default Object.freeze(ActionButtonType);
